import { api } from '@/core/lib/api-client';
import { VerifyTwoFactorCodeDto } from '@link-in-bio/domain';

export const verifyTwoFactorCode = ({ code }: VerifyTwoFactorCodeDto): Promise<boolean> => {
  return api.post(`/2fa/verify-two-factor-code?code=${code}`);
};
